<template>
  <v-container>
    <v-row>
      <v-spacer v-if="$vuetify.breakpoint.lgAndUp"/>
      <v-col cols="12" md="auto">
        <v-select
          v-model="productSelected"
          :items="products"
          item-text="name"
          item-value="id"
          label="Mặt hàng"
          class="require"
          hide-details
        >
          <template v-slot:prepend-item>
            <div class="filter-append">
              <v-text-field 
                label="Tìm mặt hàng" 
                outlined
                dense
                @input="productFilter"
                append-icon="mdi-magnify"
                class="px-3"
                clearable
                hide-details
              />
            </div>
          </template>
          <template
            slot="item"
            slot-scope="data"
          >
            <template v-if="typeof data.item !== 'object'">
              <v-list-item-content v-text="data.item"/>
            </template>
            <template v-else>
              <v-list-item-content style="max-width: 400px;">
                <v-list-item-title 
                  v-html="data.item.name"
                  :title="data.item.name"
                />
              </v-list-item-content>
            </template>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" md="auto">
        <v-select
          v-model="typeSelected"
          :items="types"
          item-text="label"
          item-value="value"
          label="Loại"
          hide-details
        />
      </v-col>
      <v-col cols="12" md="auto">
        <v-select
          v-model="yearSelected"
          :items="years"
          item-text="value"
          label="Năm"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card :loading="loading" flat>
          <Chart
            :chart-data="datacollection"
            :type="typeSelected"
            :height="1" 
            :width="4"
            @finish="onChartFinishRender"
            :data="chartData"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import Chart from '@/components/admin/market/Chart';
  import { mapActions } from 'vuex';
  export default {
    components: {
      Chart
    },
    data: () => ({
      loading: false,
      chartData: [],
      types: [
        {value: 'week', label: 'Tuần'},
        {value: 'month', label: 'Tháng'}
      ],
      typeSelected: "month",
      products: [],
      productSelected: null,
      years: [],
      yearSelected: String((new Date()).getFullYear()),
      datacollection: {},
    }),
    watch: {
      productSelected(){
        this.getChartData();
      },
      typeSelected(){
        if(this.productSelected) {
          this.getChartData();
        }
      },
      yearSelected(){
        if(this.productSelected) {
          this.getChartData();
        }
      }
    },
    mounted () {
      this.getProductTypes();
      this.getAllNamFromMarket();
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      getAllNamFromMarket(){
        axios.get("api/v1/public/get-all-year-from-market")
          .then(response => {
            this.years = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getChartData(){
        const app = this;
        let route = "get-market-chart";
        let request = {
          params: {}
        };
        if(app.typeSelected == 'week'){
          route = "get-market-chart-by-week";
          request = {
            params: {
              weekRange: {
                startWeek: 1,
                endWeek: 52
              }
            }
          };
        }
        app.loading=true;
        axios.get(`api/v1/public/${route}/${app.productSelected}/${app.yearSelected}`, request)
          .then(response => {
            app.chartData = response.data;
            app.loading=false;
          })
          .catch(function (error) {
            app.loading=false;
            console.log(error);
          });
      },
      onChartFinishRender() {
        this.loading=false;
      },
      productFilter(val) {
        const app = this;
        if (!val) {
          app.getProductTypes(); 
        } else {
          let results = [];
          app.products.forEach(function(prod){
            if(typeof prod === 'object') {
              let productName = app.$helpers.sanitizeTitle(prod.name).toLowerCase();
              let keyword = app.$helpers.sanitizeTitle(val).toLowerCase();
              if(productName.includes(keyword)){
                results.push(prod);
              }
            }
          });
          if(results.length){
            app.products=results;
          }
        }
      },
      getProductTypes () {
        const app = this;
        app.products = [];
        axios.get("api/v1/market-prod-types")
          .then(response => {
            response.data.forEach(type => {
              app.products.push({
                header: type.name
              });
              if(type.market_products){
                type.market_products.forEach(prod => {
                  app.products.push({
                    name: prod.name,
                    id: prod.id
                  });
                });
              }
            });
          })
          .catch(function (error) {
            app.openSnackbar({ 
              type: 'error',
              body: 'Lấy nhóm giá không thành công!'
            });
          });
      },
    }
  }
</script>
<style scoped>
  .filter-append{
    position:sticky;
    top: 0;
    padding-top: 8px;
    padding-bottom: 8px;
    width:100%;
    display:flex;
    justify-content :center;
    background :white;
    z-index: 1;
  }
</style>